import { reactive } from "@vue/composition-api";
import axios from "axios";

export default function (url, initialData) {
  const form = reactive({
    value: JSON.parse(JSON.stringify(initialData)),
    isSubmitting: false,
    errorMessage: null,
    errors: {},
  });

  function submit() {
    form.isSubmitting = true;
    form.errorMessage = null;
    form.errors = {};
    return axios
      .post(url, form.value)
      .then((response) => {
        form.isSubmitting = false;
        return response.data;
      })
      .catch((error) => {
        form.isSubmitting = false;
        const details = error.response && error.response.data;
        if (details) {
          form.errors = details.errors;
        }
        throw error;
      });
  }
  return {
    form,
    formSubmit: submit,
  };
}
